import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current text-white w-6 h-6 p-0.5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_2 = { class: "flex flex-col space-y-1 z-50 px-4 py-5 bg-brand-black border-b border-brand-dark-gray" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "attribution",
  class: "text-white"
}, null, -1)
const _hoisted_4 = { class: "flex flex-col pb-5 px-4 justify-center space-y-4 relative" }
const _hoisted_5 = { class: "flex w-full overflow-scroll" }
const _hoisted_6 = { class: "flex flex-col space-y-6 divide-y divide-brand-dark-gray w-full" }
const _hoisted_7 = ["onClick"]

import {

  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonToolbar,
  modalController,
} from '@ionic/vue';
import {onMounted, ref, watch} from 'vue';
import {useGoogleMaps} from "@/composables/useGoogleMaps";
import InputField from "@/components/InputField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseLocationPage',
  setup(__props) {

const loading = ref(true)
const location = ref()
const locationName = ref('')
const locationSearch = ref('')
const locations = ref([])

onMounted(async () => {
  loading.value = false
})

const places = ref()

onMounted(async () => {
  await useGoogleMaps().loadSDK()
  const attributionEl: any = document.querySelector('#attribution')
  // eslint-disable-next-line no-undef
  places.value = new google.maps.places.PlacesService(attributionEl)
  loading.value = false
})

const updateLocationSearch = async (value: any) => {
  locationSearch.value = value
}

const chooseLocation = async (value: any) => {
  location.value = value
  locationName.value = value.formatted_address
  locations.value = []

  await modalController.dismiss({
    name: location.value.formatted_address,
    lat: location.value.geometry.location.lat(),
    lng: location.value.geometry.location.lng()
  })
}

watch(() => locationSearch.value, searchValue => {

  if (!searchValue) {
    locations.value = []
    location.value = undefined
    return
  }

  if (searchValue === locationName.value) return

  // eslint-disable-next-line no-undef
  places.value.textSearch({
    query: searchValue,
    types: ['(cities)']
  }, (response: any) => {
    locations.value = response
  })

})

const goBack = async () => {
  await modalController.dismiss()
}

const done = async () => {
//
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "!p-0 !m-0" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { class: "justify-between flex w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  onClick: goBack,
                  class: "bg-brand-dark-gray rounded-md"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InputField, {
            id: "locationSearch",
            type: "text",
            modelValue: locationName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((locationName).value = $event)),
            debounce: 300,
            "clear-input": true,
            counter: false,
            onOnChange: _cache[1] || (_cache[1] = ($event: any) => (updateLocationSearch($event))),
            onOnKeyEnter: _cache[2] || (_cache[2] = () => console.log('enter')),
            placeholder: "e.g. Stoke"
          }, null, 8, ["modelValue"]),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (location, locationKey) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex text-white text-lg pt-6",
                  onClick: ($event: any) => (chooseLocation(location)),
                  key: locationKey
                }, _toDisplayString(location.formatted_address), 9, _hoisted_7))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})